import { render, staticRenderFns } from "./TabProcess.vue?vue&type=template&id=01110496"
import script from "./TabProcess.vue?vue&type=script&lang=js"
export * from "./TabProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports